// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
  min-width: 200px;
  max-width: 200px;
  min-height: 100vh;
  color: #fff;
  transition: all 0.3s;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5;
}

#sidebar.hidden {
  margin-left: -200px;
}

a[data-toggle='collapse'] {
  position: relative;
}

@media (max-width: 575px) {
  #sidebar {
    margin-left: -200px;
  }
  #sidebar.hidden {
    margin-left: 0;
  }
}

#sidebar .sidebar-header {
  padding: 20px;
}

#sidebar ul li a {
  padding: 15px;
  display: block;
  width: 100%;
  /* &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  } */
}

hr {
  border-top: 1px solid #fff;
  margin-top: 0;
}
/**tabbar left navigation starts**/
.leftNav {
  height: 100%;
  background-color: #fff;
  /* position: relative; */
  position: absolute;
  overflow-y: auto;
  top: 0;
  left: 0;
  min-width: 170px;
  max-width: 210px;
  z-index: 999;
  width: 250px;
  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);
}
.leftNavContent {
  width: 100%;
  /* height: 100%; */
  background-color: #fff;
  position: relative;
  z-index: 9;
  display: flex;
  flex-direction: column;
}
.leftNavContent .profileContent {
  padding: 1.95rem 1rem 0.15rem;
  /* display: flex;
  justify-content: left;
  align-items: initial;
  flex-direction: column; */
  min-height: 8rem;
  width: 100%;
  background: rgb(16, 4, 208);
  background: linear-gradient(
    90deg,
    rgba(16, 4, 208, 1) 0%,
    rgba(13, 113, 232, 1) 35%,
    rgba(67, 216, 246, 1) 100%
  );
  color: #ffffff;
}
.leftNavContent .profileContent > span {
  background: rgb(51 102 255 / 70%);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 8px;
  color: #fff;
  font-size: 1.6rem;
}
.leftNavContent .profileContent > h6 {
  margin: 0;
  font-size: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.leftNavContent .menubar {
  width: 100%;
  /* height: calc(100% - 145px); */
  height: calc(100% - 32rem);
}
.leftNav ul.lnUl {
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}
.leftNav ul.lnUl li {
  display: block;
  padding: 0 5px 0 0;
}
.leftNav ul.lnUl li > a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #222b45;
  border-bottom: 1px solid #edf1f7;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  font-weight: normal;
  padding: 14px 25px 14px 15px;
}
.leftNav ul.lnUl li:last-child > a {
  border-bottom-color: transparent;
}
.leftNav ul.lnUl li:hover > a,
.leftNav ul.lnUl li:hover > a > i {
  color: #36f;
}
.leftNav ul.lnUl li > a.active,
.leftNav ul.lnUl li > a.active > i {
  color: #36f;
}
.leftNav ul.lnUl li > a.active::before {
  content: '';
  width: 3px;
  height: 100%;
  background-color: #7f8dff;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
}
.leftNav ul.lnUl li > a > span {
  display: block;
  font-size: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: normal;
}
.leftNav ul.lnUl li > a > i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  margin-right: 10px;
  width: 20px;
  color: #828c9f;
}
.leftNav ul.lnUl > li:hover ul {
  background-color: rgba(0, 0, 0, 0.01);
}
.leftNav ul.lnUl li.hasSubMenu > a:after {
  content: '\\e908';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'icomoon';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}
.leftNav ul.lnUl li.hasSubMenu > a.activeTab:after {
  transform: translateY(-50%) rotate(90deg);
}
.leftNav ul.lnUl > li.hasSubMenu ul {
  display: none;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li {
  padding: 0;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li > a {
  padding-left: 30px;
  color: #617d95;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li > a:hover {
  color: #36f;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul {
  position: fixed;
  top: 400px;
  left: 235px;
  z-index: 99;
  box-shadow: 0 7px 18px -8px #000;
  -webkit-box-shadow: 0 7px 18px -8px #000;
  -moz-box-shadow: 0 7px 18px -8px #000;
  background-color: #fff;
  overflow: hidden;
  overflow-y: auto;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {
  color: #153d77;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul.active {
  display: block;
  background-color: #f2f2f2;
}
.menuClosed .leftNav {
  margin-left: -250px;
}
.leftNavActionbar {
  height: 45px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.leftNavActionbar a {
  background-color: #8f9bb3;
  color: #fff;
  padding: 10px 15px;
  height: 45px;
  display: flex;
  width: 100%;
}
/**tabbar left navigation ends**/

@media (max-width: 767px) {
  .leftNav {
    position: fixed;
    top: 50px;
    z-index: 98;
    height: calc(100% - 50px);
  }
}
.btnToggleBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  /* background-color: #f2f5ff; */
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
  font-size: 0.6rem;
}

.profileContent .block > h4 {
  border-bottom: none !important;

  padding-bottom: 0px !important
   ;
}

.leftNav .userSetting ul.lnUl li > a {
  border-bottom: 1px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);
}

.signout {
  background: linear-gradient(to left, #1bd2f7, #c0eef7);
}
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .leftNav {
    width: 170px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/menu/menu.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX;;KAEG;AACL;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA,kCAAkC;AAClC;EACE,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B;;;2BAGyB;EACzB,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B;;;;;GAKC;EACD,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA,gCAAgC;;AAEhC;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;;EAE9B;GACC;AACH;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,sDAAsD;AACxD;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["#sidebar {\r\n  min-width: 200px;\r\n  max-width: 200px;\r\n  min-height: 100vh;\r\n  color: #fff;\r\n  transition: all 0.3s;\r\n  font-weight: 300;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n#sidebar.hidden {\r\n  margin-left: -200px;\r\n}\r\n\r\na[data-toggle='collapse'] {\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  #sidebar {\r\n    margin-left: -200px;\r\n  }\r\n  #sidebar.hidden {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n#sidebar .sidebar-header {\r\n  padding: 20px;\r\n}\r\n\r\n#sidebar ul li a {\r\n  padding: 15px;\r\n  display: block;\r\n  width: 100%;\r\n  /* &:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n  } */\r\n}\r\n\r\nhr {\r\n  border-top: 1px solid #fff;\r\n  margin-top: 0;\r\n}\r\n/**tabbar left navigation starts**/\r\n.leftNav {\r\n  height: 100%;\r\n  background-color: #fff;\r\n  /* position: relative; */\r\n  position: absolute;\r\n  overflow-y: auto;\r\n  top: 0;\r\n  left: 0;\r\n  min-width: 170px;\r\n  max-width: 210px;\r\n  z-index: 999;\r\n  width: 250px;\r\n  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);\r\n}\r\n.leftNavContent {\r\n  width: 100%;\r\n  /* height: 100%; */\r\n  background-color: #fff;\r\n  position: relative;\r\n  z-index: 9;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.leftNavContent .profileContent {\r\n  padding: 1.95rem 1rem 0.15rem;\r\n  /* display: flex;\r\n  justify-content: left;\r\n  align-items: initial;\r\n  flex-direction: column; */\r\n  min-height: 8rem;\r\n  width: 100%;\r\n  background: rgb(16, 4, 208);\r\n  background: linear-gradient(\r\n    90deg,\r\n    rgba(16, 4, 208, 1) 0%,\r\n    rgba(13, 113, 232, 1) 35%,\r\n    rgba(67, 216, 246, 1) 100%\r\n  );\r\n  color: #ffffff;\r\n}\r\n.leftNavContent .profileContent > span {\r\n  background: rgb(51 102 255 / 70%);\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  margin-bottom: 8px;\r\n  color: #fff;\r\n  font-size: 1.6rem;\r\n}\r\n.leftNavContent .profileContent > h6 {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.leftNavContent .menubar {\r\n  width: 100%;\r\n  /* height: calc(100% - 145px); */\r\n  height: calc(100% - 32rem);\r\n}\r\n.leftNav ul.lnUl {\r\n  height: 100%;\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.leftNav ul.lnUl li {\r\n  display: block;\r\n  padding: 0 5px 0 0;\r\n}\r\n.leftNav ul.lnUl li > a {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  color: #222b45;\r\n  border-bottom: 1px solid #edf1f7;\r\n  position: relative;\r\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\r\n  font-weight: normal;\r\n  padding: 14px 25px 14px 15px;\r\n}\r\n.leftNav ul.lnUl li:last-child > a {\r\n  border-bottom-color: transparent;\r\n}\r\n.leftNav ul.lnUl li:hover > a,\r\n.leftNav ul.lnUl li:hover > a > i {\r\n  color: #36f;\r\n}\r\n.leftNav ul.lnUl li > a.active,\r\n.leftNav ul.lnUl li > a.active > i {\r\n  color: #36f;\r\n}\r\n.leftNav ul.lnUl li > a.active::before {\r\n  content: '';\r\n  width: 3px;\r\n  height: 100%;\r\n  background-color: #7f8dff;\r\n  z-index: 2;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.leftNav ul.lnUl li > a > span {\r\n  display: block;\r\n  font-size: 0.9rem;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  line-height: normal;\r\n}\r\n.leftNav ul.lnUl li > a > i {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 1.2rem;\r\n  margin-right: 10px;\r\n  width: 20px;\r\n  color: #828c9f;\r\n}\r\n.leftNav ul.lnUl > li:hover ul {\r\n  background-color: rgba(0, 0, 0, 0.01);\r\n}\r\n.leftNav ul.lnUl li.hasSubMenu > a:after {\r\n  content: '\\e908';\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 15px;\r\n  transform: translateY(-50%);\r\n  font-family: 'icomoon';\r\n  font-weight: normal;\r\n  font-size: 0.7rem;\r\n  transition: all 0.2s ease-out;\r\n}\r\n.leftNav ul.lnUl li.hasSubMenu > a.activeTab:after {\r\n  transform: translateY(-50%) rotate(90deg);\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu ul {\r\n  display: none;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul li {\r\n  padding: 0;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul li > a {\r\n  padding-left: 30px;\r\n  color: #617d95;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul li > a:hover {\r\n  color: #36f;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul {\r\n  position: fixed;\r\n  top: 400px;\r\n  left: 235px;\r\n  z-index: 99;\r\n  box-shadow: 0 7px 18px -8px #000;\r\n  -webkit-box-shadow: 0 7px 18px -8px #000;\r\n  -moz-box-shadow: 0 7px 18px -8px #000;\r\n  background-color: #fff;\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {\r\n  color: #153d77;\r\n}\r\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul.active {\r\n  display: block;\r\n  background-color: #f2f2f2;\r\n}\r\n.menuClosed .leftNav {\r\n  margin-left: -250px;\r\n}\r\n.leftNavActionbar {\r\n  height: 45px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.leftNavActionbar a {\r\n  background-color: #8f9bb3;\r\n  color: #fff;\r\n  padding: 10px 15px;\r\n  height: 45px;\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n/**tabbar left navigation ends**/\r\n\r\n@media (max-width: 767px) {\r\n  .leftNav {\r\n    position: fixed;\r\n    top: 50px;\r\n    z-index: 98;\r\n    height: calc(100% - 50px);\r\n  }\r\n}\r\n.btnToggleBlock {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  /* background-color: #f2f5ff; */\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  font-size: 0.6rem;\r\n}\r\n\r\n.profileContent .block > h4 {\r\n  border-bottom: none !important;\r\n\r\n  padding-bottom: 0px !important\r\n   ;\r\n}\r\n\r\n.leftNav .userSetting ul.lnUl li > a {\r\n  border-bottom: 1px solid;\r\n  border-image-slice: 1;\r\n  border-width: 1px;\r\n  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);\r\n}\r\n\r\n.signout {\r\n  background: linear-gradient(to left, #1bd2f7, #c0eef7);\r\n}\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\r\n  .leftNav {\r\n    width: 170px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
